import { Injectable } from '@angular/core';
import { B2pService } from '@core/services/b2p/b2p.service';
import { UserDataService } from '@core/services/user-data/user-data.service';
import { IProductCommandContext } from '@shared/models/command';
import { BaseProductCommand } from '@shared/commands/base-product.command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class B2pCommand extends BaseProductCommand {
  readonly type = 'b2p';
  readonly title = 'Погасить с карты другого банка';
  readonly icon = 'replenish';
  readonly productType = ProductTypes.CREDIT;
  readonly isInfoAction = false;
  readonly settingsNames = undefined;
  readonly order = 2; // Второй в actions для credit

  constructor(
    private userDataService: UserDataService,
    private b2pService: B2pService,
    commandAvailabilityService: CommandAvailabilityService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    this.userDataService.getClientInfo().subscribe(info => {
      const number = context.data.creditInformation.repaymentAccount;

      this.b2pService.openB2P(info, number);
    });
  }

  protected checkAdditionalAvailability(context: IProductCommandContext): Observable<boolean> | boolean {
    return !!context.data.creditInformation?.repaymentAccount;
  }
}

